import {CompetitorNewsPageRouteMetaDataModel} from "./competitor.news-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorNewsPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.news,
      path: `news`,
      componentImport: () => import("../components/competitor.news-page" /* webpackChunkName: "competitor.news-page" */ ),
      metadataType: CompetitorNewsPageRouteMetaDataModel
    });
  }
}